

import { createUseStyles } from "react-jss";

interface Props {
  buttonType: any;
  maxWidth: any;
};

const useStyles = createUseStyles((theme: any) => ({
  normalButton: {
    borderWidth: (props: Props) => {
      if(props.buttonType === "primaryOutlined") return "3px";
      else if(props.buttonType === "darkBlueOutlined") return "3px";
      else if(props.buttonType === "blackOutlined") return "3px";
      else return "3px";   
    },
    borderStyle: 'solid',
    borderColor: (props: Props) => {
      if(props.buttonType === "primaryOutlined") return theme.colors.primaryBlue[500];
      else if(props.buttonType === "darkBlueOutlined") return "#003164";
      else if(props.buttonType === "blackOutlined") return theme.colors.black;
      else return "transparent";   
    },
    backgroundColor: (props: Props) => {
      if(props.buttonType === "primary") return theme.colors.primaryBlue[500];
      else if(props.buttonType === "secondary") return theme.colors.grey[200];
      else if(props.buttonType === "tertiary") return theme.colors.white;    
      else if(props.buttonType === "disabled") return theme.colors.grey[75];
      else if(props.buttonType === "chip") return theme.colors.grey[200];
      else if(props.buttonType === "filter") return theme.colors.white;
      else if(props.buttonType === "blue") return theme.colors.grey[250];
      else if(props.buttonType === "darkBlue") return "#003164";
      else if(props.buttonType === "darkBlueOutlined") return "transparent"
      else if(props.buttonType === "red") return "#FFF1F3";
      else if(props.buttonType === "yellow") return "#FFF2DA";
      else if(props.buttonType === "white") return theme.colors.white;
      else if(props.buttonType === "black") return theme.colors.black;
      else if(props.buttonType === "blackOutlined") return "transparent";
      else if(props.buttonType === "brand") return theme.colors.primaryBlue[500];
      else if(props.buttonType === "clear") return theme.colors.systemRed[500];
      else if(props.buttonType === "reacted") return theme.colors.primaryBlue[50];
      else if(props.buttonType === "saved") return theme.colors.systemRed[75];
      else return "transparent";     
    },
    color: (props: Props) => {
      if(props.buttonType === "text") return theme.colors.black;
      else return '';
    },
    padding: (props: Props) => {
      if(props.buttonType === "text") return "0px";
      else return "9px 21px";
    },
    borderRadius: "10px",
    height: (props: Props) => {
      if(props.buttonType === "text") return "";
      else return "42px";
    },
    minWidth: (props: Props) => {
      if(props.buttonType === "text") return "";
      else return "120px";
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: "center",
    transition: 'all 0.25s',
    textTransform: 'none',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      fontSize: (props: Props) => {
        if(props.buttonType === "text") return "12px";
        else return "14px";
      },
      fontWeight: (props: Props) => {
        if(props.buttonType === "text") return "400";
        else return "500";
      },
      whiteSpace: "nowrap",
      color: (props: Props) => {
        if(props.buttonType === "primary") return theme.colors.alwaysWhite;
        else if(props.buttonType === "primaryOutlined") return theme.colors.primaryBlue[500];
        else if(props.buttonType === "secondary") return theme.colors.grey[800];
        else if(props.buttonType === "tertiary") return theme.colors.grey[800];
        else if(props.buttonType === "disabled") return theme.colors.grey[560];
        else if(props.buttonType === "chip") return theme.colors.grey[700];
        else if(props.buttonType === "filter") return theme.colors.grey[560];
        else if(props.buttonType === "cancel") return "#F44336";
        else if(props.buttonType === "info") return theme.colors.primaryBlue[250];
        else if(props.buttonType === "warning") return "#FFCC00";
        else if(props.buttonType === "blue") return theme.colors.primaryBlue[500];
        else if(props.buttonType === "darkBlue") return theme.colors.white;
        else if(props.buttonType === "darkBlueOutlined") return "#003164";
        else if(props.buttonType === "red") return "#EE576C";
        else if(props.buttonType === "yellow") return "#FFC632";
        else if(props.buttonType === "white") return theme.colors.black;
        else if(props.buttonType === "black") return theme.colors.white;
        else if(props.buttonType === "blackOutlined") return theme.colors.black;
        else if(props.buttonType === "brand") return theme.colors.alwaysWhite;
        else if(props.buttonType === "clear") return theme.colors.alwaysWhite;
        else if(props.buttonType === "reacted") return theme.colors.primaryBlue[400];
        else if(props.buttonType === "saved") return theme.colors.systemRed[400];
        else if(props.buttonType === "text") return 'inherit';
      },
      '& > svg': {
        display: (props: Props) => {
          if(props.buttonType === "text") return 'none';
          else return '';
        },
      },
    },
    '&:hover': {
      backgroundColor: (props: Props) => {
        if(props.buttonType === "primary") return theme.colors.primaryBlue[600];
        else if(props.buttonType === "secondary") return theme.colors.grey[300];
        else if(props.buttonType === "tertiary") return theme.colors.grey[125];
        else if(props.buttonType === "chip") return theme.colors.grey[200];
        else if(props.buttonType === "darkBlue") return "#013164";
        else if(props.buttonType === "brand") return theme.colors.primaryBlue[500];
        else if(props.buttonType === "clear") return theme.colors.systemRed[400];
        else if(props.buttonType === "white") return "#F2F2F2";
        else if(props.buttonType === "black") return "#111111";
        else if(props.buttonType === "reacted") return theme.colors.primaryBlue[100];
        else if(props.buttonType === "saved") return theme.colors.systemRed[100];
        else return 'transparent';
      },
      color: (props: Props) => {
        if(props.buttonType === "text") return theme.colors.primaryBlue[500];
        else return '';
      },
      boxShadow: (props: Props) => {
        if(props.buttonType === "chip") return "0px 5px 7px 0px rgba(158, 158, 158, 0.5)";
        else return 'none';
      },
      borderColor: (props: Props) => {
        if(props.buttonType === "primaryOutlined") return theme.colors.primaryBlue[600];
        else return '';
      }
    },
  },
  tooltipWidth: {
    maxWidth: (props: Props) => props.maxWidth + 'px',
  },
}));

export default useStyles;